import PropTypes from "prop-types"

import StepDetails from "./step_details"
import styles from "./styles.module.scss"

const ActivitySteps = ({ applet, filterIconUrl, runDetails, aiActionAssistIconUrl }) => {
  const filterStep = details => {
    let filterCodeRunDetails = details?.find(obj => obj.step === "filter")

    if (!filterCodeRunDetails?.message) return null

    return {
      id: "filter",
      name: "This Applet has a filter that can affect how its actions run",
      icon_url: filterIconUrl,
      brand_color: "#eee",
      service_name: "Filter",
      detailsForStep: {
        step: filterCodeRunDetails.step,
        message: filterCodeRunDetails.message,
        message_title: filterCodeRunDetails.message_title,
        outcome: filterCodeRunDetails.outcome,
        ts: filterCodeRunDetails.ts,
      },
    }
  }

  const aiActionAssistStep = details => {
    let aiActionAssistRunDetails = details?.find(obj => obj.step === "ai_action_assist")

    if (!aiActionAssistRunDetails) return null

    return {
      id: "ai_action_assist",
      name: aiActionAssistRunDetails.label,
      icon_url: aiActionAssistIconUrl,
      brand_color: "#1e2023",
      service_name: "AI Action assist",
      detailsForStep: {
        step: aiActionAssistRunDetails.step,
        message: aiActionAssistRunDetails.message,
        message_title: aiActionAssistRunDetails.message_title,
        outcome: aiActionAssistRunDetails.outcome,
        ts: aiActionAssistRunDetails.ts,
        fields: aiActionAssistRunDetails.fields,
      },
    }
  }

  const delayStep = details => {
    if (details?.some(obj => obj.outcome === "delay_skip")) return null

    let delayRunDetails = details?.find(obj => obj.step === "delay")

    if (!delayRunDetails?.actions_delay) return null

    return {
      id: "delay",
      name: "delay before the next action",
      icon_url: "",
      brand_color: "#1e2023",
      service_name: "Delay",
      detailsForStep: {
        step: delayRunDetails.step,
        actions_delay: delayRunDetails.actions_delay,
        ts: delayRunDetails.ts,
        outcome: delayRunDetails.outcome,
      },
    }
  }

  const firstActionIndex = applet.permissions.findIndex(obj => obj.id.startsWith("/actions/"))
  const permissions = [
    ...applet.permissions.slice(0, firstActionIndex),
    filterStep(runDetails),
    aiActionAssistStep(runDetails),
    delayStep(runDetails),
    ...applet.permissions.slice(firstActionIndex),
  ].filter(Boolean)

  return (
    <div className={styles["activity-steps"]}>
      {permissions.map((step, i) => (
        <StepDetails
          key={step.id}
          firstStep={i === 0}
          finalStep={permissions.length === i + 1}
          detailsForStep={
            ["filter", "ai_action_assist", "delay"].includes(step.id)
              ? step.detailsForStep
              : runDetails?.find(
                  stepDetail => stepDetail.permission_id === step.id
                )
          }
          brand_color={step.brand_color}
          icon_url={step.icon_url}
          id={step.id}
          name={step.name}
          service_name={step.service_name}
        />
      ))}
    </div>
  )
}

ActivitySteps.propTypes = {
  applet: PropTypes.object,
  filterIconUrl: PropTypes.string,
  aiActionAssistIconUrl: PropTypes.string,
  runDetails: PropTypes.array,
}

export default ActivitySteps
